import * as React from 'react';
import SwipeContainer from './SwipeContainer';
import Slide from './Slide';
const DefaultSlideTimeout = 8000;
class MatchStage extends React.Component {
    constructor() {
        super(...arguments);
        this.timer = null;
        this.autoSlideDisabled = false;
        this.state = {
            activeIndex: 0
        };
        this.getSlides = (props = this.props) => {
            const children = React.Children.toArray(props.children);
            // @ts-ignore
            return children.filter(child => child.type && child.type === Slide);
        };
        this.handleSlideChange = (index) => {
            const slideComponent = this.getSlides(this.props)[index];
            if (this.props.onSlideChange)
                this.props.onSlideChange(index, slideComponent.props.type);
        };
        this.enableTimer = () => {
            if (this.timer)
                window.clearTimeout(this.timer);
            if (!this.props.autoSlide || this.autoSlideDisabled)
                return;
            this.timer = window.setTimeout(() => {
                this.slideRight();
            }, DefaultSlideTimeout);
        };
        this.disableTimer = () => {
            if (this.timer)
                window.clearTimeout(this.timer);
        };
        this.slideLeft = () => {
            this.setState(prevState => ({
                activeIndex: prevState.activeIndex !== 0 ? prevState.activeIndex - 1 : Math.max(0, this.getSlides().length - 1)
            }));
            this.enableTimer();
        };
        this.slideRight = () => {
            this.setState(prevState => ({
                activeIndex: (prevState.activeIndex + 1) % Math.max(1, this.getSlides().length)
            }));
            this.enableTimer();
        };
        this.swipeToIndex = (index, disableAutoSwipe) => {
            this.setState({
                activeIndex: index % Math.max(1, this.getSlides().length)
            });
        };
        this.disableAutoSlide = () => {
            if (!this.props.autoSlide)
                return;
            this.autoSlideDisabled = true;
            this.disableTimer();
        };
        this.enableAutoSlide = () => {
            if (!this.props.autoSlide)
                return;
            this.autoSlideDisabled = false;
            this.enableTimer();
        };
    }
    componentDidMount() {
        if (this.props.autoSlide)
            this.enableAutoSlide();
        this.handleSlideChange(this.state.activeIndex);
        if (this.props.onSlideCountChange) {
            const currentSlideCount = this.getSlides().length;
            this.props.onSlideCountChange(currentSlideCount);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.activeIndex !== this.state.activeIndex) {
            this.handleSlideChange(this.state.activeIndex);
        }
        if (this.props.onSlideCountChange) {
            const currentSlideCount = this.getSlides().length;
            const prevSlideCount = this.getSlides(prevProps).length;
            if (currentSlideCount !== prevSlideCount) {
                this.props.onSlideCountChange(currentSlideCount);
            }
        }
    }
    componentWillUnmount() {
        if (this.timer)
            window.clearTimeout(this.timer);
    }
    render() {
        const { animate, dotsContainer } = this.props;
        const { activeIndex } = this.state;
        const children = this.getSlides();
        return (React.createElement("div", { onMouseEnter: this.disableAutoSlide, onMouseLeave: this.enableAutoSlide, onTouchStart: this.disableAutoSlide, onTouchEnd: this.enableAutoSlide },
            dotsContainer && children.length > 1
                ? React.cloneElement(dotsContainer, {
                    activeIndex: activeIndex,
                    numPills: children.length,
                    onClick: this.swipeToIndex
                })
                : null,
            React.createElement(SwipeContainer, { selectedIndex: activeIndex, duration: animate ? 1000 : 0, onSwipe: this.swipeToIndex, amountOfItemsPerColumn: 1 }, children)));
    }
}
export default MatchStage;
//# sourceMappingURL=MatchStage.js.map